(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('prog-elig-facility', {
            parent: 'entity',
            url: '/prog-elig-facility',
            data: {
                authorities: [],
                pageTitle: 'ProgEligFacilities'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/prog-elig-facility/prog-elig-facilities.html',
                    controller: 'ProgEligFacilityController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_FACILITY_PROGRAM_ELIGIBILITY];
                    return Auth.loadActionsAccess(actions).$promise;
                }],
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_FACILITY_PROGRAM_ELIGIBILITY, access);
                }]
            }
        })
        .state('prog-elig-facility.new', {
            parent: 'prog-elig-facility',
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'CoreService', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, CoreService, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_FACILITY_PROGRAM_ELIGIBILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prog-elig-facility/prog-elig-facility-dialog.html',
                        controller: 'ProgEligFacilityDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    startDate: null,
                                    endDate: null,
                                    id: null,
                                    facility: CoreService.getCurrentFacility()
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('prog-elig-facility', null, {reload: 'prog-elig-facility'});
                    }, function () {
                        $state.go('prog-elig-facility');
                    });
                }
            }]
        })
        .state('prog-elig-facility.edit', {
            parent: 'prog-elig-facility',
            url: '/{id}/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_FACILITY_PROGRAM_ELIGIBILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prog-elig-facility/prog-elig-facility-dialog.html',
                        controller: 'ProgEligFacilityDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'lg',
                        resolve: {
                            entity: ['ProgEligFacility', function (ProgEligFacility) {
                                return ProgEligFacility.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('prog-elig-facility', null, {reload: 'prog-elig-facility'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        })
        .state('prog-elig-facility.delete', {
            parent: 'prog-elig-facility',
            url: '/{id}/delete',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_FACILITY_PROGRAM_ELIGIBILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prog-elig-facility/prog-elig-facility-delete-dialog.html',
                        controller: 'ProgEligFacilityDeleteController',
                        controllerAs: 'vm',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'md',
                        resolve: {
                            entity: ['ProgEligFacility', function (ProgEligFacility) {
                                return ProgEligFacility.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('prog-elig-facility', null, {reload: 'prog-elig-facility'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        });
    }
})();
